var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.company.logo_url,"alt":_vm.company.trading_name}}),_c('CRMHeader'),_c('b-container',{staticClass:"mt-3 mb-3"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }